import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Query } from 'redux-little-router';

import { Action } from '../../actions';
import { loadBannersPreview } from '../../actions/banners-preview';
import { changeLocation } from '../../actions/common';
import {
    GridBannerPreviewCell,
    GridBannerPreviewCellProps
} from '../../components/GridBannerPreviewCell/GridBannerPreviewCell';
import { BannerCriteriaKey, BannerCriteriaSetTitles } from '../../declarations/filter/filter';
import { serializeFilterToString } from '../../service/FilterHelpers/FilterHelpers';
import { UrlHelpers } from '../../service/UrlHelpers';
import { banners as bannersView, GRID_PREFIX } from '../../typings/common';
import { FilterExpressionValueType, Operator } from '../../typings/filter';
import { State } from '../../typings/state';
import { Omit, TDispatchProps, TStateProps } from '../../typings/utils';

export type OwnProps = Pick<GridBannerPreviewCellProps, 'bannersTotalCount' | 'isTextBanner' | 'id'> & {
    campaignId: string;
    groupId: string;
};

export type StateProps = TStateProps<GridBannerPreviewCellProps, OwnProps> & {
    login: string;
};

export type DispatchProps = Omit<TDispatchProps<GridBannerPreviewCellProps, OwnProps>, 'onGoToBannersButtonClick'> & {
    onGoToBannersButtonClick: (href: string, query: Query) => void;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { groupId } = ownProps;
    const {
        bannersPreviewData,
        grid: { isGridScrolling }
    } = state;
    const previewData = bannersPreviewData[groupId] || {};
    const { banners } = previewData;
    const { login } = state.commonData;

    return {
        isGridScrolling,
        login,
        banners
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { campaignId, groupId } = ownProps;

    return {
        onClick: () => {
            dispatch(loadBannersPreview(campaignId, groupId));
        },
        onGoToBannersButtonClick: (href: string, query: Query) => {
            dispatch(changeLocation(href, query, false));
        }
    };
};

export type MergedProps = GridBannerPreviewCellProps;

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): MergedProps => {
    const { login, ...filteredStateProps } = stateProps;
    const { onGoToBannersButtonClick, ...filteredDispatchProps } = dispatchProps;
    const { campaignId, ...otherProps } = ownProps;

    return {
        ...filteredStateProps,
        ...filteredDispatchProps,
        ...otherProps,
        onGoToBannersButtonClick: (bannerIds: string[]) => {
            const filter = serializeFilterToString([
                {
                    field: BannerCriteriaSetTitles[BannerCriteriaKey.id],
                    operator: Operator.EQUALS,
                    value: {
                        type: FilterExpressionValueType.numberSet,
                        value: bannerIds
                    }
                }
            ]);

            onGoToBannersButtonClick(UrlHelpers.createNewDirectUrlPathByParams(GRID_PREFIX, bannersView), {
                ulogin: login,
                filter
            });
        }
    };
};

export const GridBannerPreviewCellContainer = connect<StateProps, DispatchProps, OwnProps, MergedProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(GridBannerPreviewCell);
